<template>
  <div class="lobby-widget-container">
    <div class="lobby-border">
      <div class="lobby-content">
        <h4>Volte para sua partida ( <router-link :to="{ name: 'LobbySingle', params: { id: this.lobby.id }}"><small>ver stats</small></router-link> )</h4>
        <div class="form-elements">
          <a v-if="false" href="steam://run/282660" class="btn btn-secondary btn-sm anticheater" v-b-tooltip.hover title="primeiro abra o anticheater (com o jogo fechado)">
            <i class="fab fa-qq"></i>
            anticheater
          </a>
          <b-form-input 
            :value="serverConnectAddress"
            type="text"
            v-clipboard:copy="serverConnectAddress"
            v-b-tooltip.hover title="clique para copiar e cole no console"
            class="server-ip"></b-form-input>
          
          <a :href="openGameLink" class="btn btn-sm primary">
            <i class="fas fa-external-link-alt"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LobbyWidget',
  data () {
    return {
      playersCount: 0,
      interval: null
    }
  },
  computed : {
    openGameLink: function() { return `steam://run/730//+connect ${this.lobby.pug_server.ip} +password ${this.lobby.pug_server.server_password}` },
    serverConnectAddress: function() { return `connect ${this.lobby.pug_server.ip}; password ${this.lobby.pug_server.server_password}` },
    server_ip: function() { return `${this.$store.getters.lobby.pug_server.ip}` },
    lobby: function() { return this.$store.getters.lobby }
  },
  methods: {
    initialize() {
      var self = this
      
      if(this.lobby.id)
        this.$http
          .get(`lobbies/${this.lobby.id}.json`)
          .then((response) => {
            if(response.data.status == 'match-ended') {
              self.$store.commit('clearLobby')
            }
          }).catch((response) => {
            self.$store.commit('clearLobby')
          })
    }
  },
  mounted () {
    this.initialize()
    // this.interval = setInterval(() => {
    //   this.initialize()
    // }, 7000)
  },
  beforeDestroy () {
    // clearInterval(this.interval)
  }
}
</script>

<style lang="sass" scoped>
.lobby-widget-container
  position: fixed
  bottom: 10px
  left: 0
  width: 304px
  height: 90px
  // background: rgba(0, 0, 0, .4)
  background: linear-gradient(5deg, rgba(164,4,4,1.8673844537815126) 35%, rgba(51,5,5,0.8869922969187675) 66%)

  z-index: 10
  border-top-right-radius: 4px
  border-bottom-right-radius: 4px

  .lobby-border
    // background: rgba(255, 255, 255, .6)
    // background: linear-gradient(45deg, rgba(255,255,255,0.4) 15%, rgba(255,255,255,0.3) 66%)

    border-top-right-radius: 4px
    border-bottom-right-radius: 4px
    
    position: absolute
    width: 300px
    height: 82px
    top: 4px
  
    .lobby-content
      padding: 10px

      h4
        font-size: 12px
        color: white
        text-transform: uppercase
      
      .form-elements
        display: flex
        .server-ip
          width: 100%
          background: rgba(255, 255, 255, .1)
          margin-right: 2px
          color: white
          font-size: 11px
        .anticheater
          background: rgba(blueviolet, .8)
          border: 0
          outline: 0
          // width: 38px
          padding-top: 9px
          margin-right: 2px
        .primary
          background: rgba(black, .6)
          border: 0
          outline: 0
          padding-top: 9px
          color: white
</style>
